import { Icon } from './icon'
import MultiSelect from './multi-select'

class MultiAttachment extends MultiSelect {
  constructor (el) {
    super(el)

    this.containers = document.querySelectorAll('.attachments-container')
    this.hiddenPrimaryField = el.querySelector('.hidden-primary-field')
    this.bulkDeleteButton = el.querySelector('#resource-delete')
    this.indivdualResourceRemovalButton = Array.from(el.querySelectorAll('.icon-container'))
    this.attachedFiles = Array.from(document.querySelectorAll('.file-container'))
  }

  init () {
    this.containerVisibility()

    this.determineCheckboxStatus('attachment')
    this.hoverMenuHandler()
    this.initEventListeners()
    this.changeBackgroundColor()
  }

  containerVisibility () {
    this.containers.forEach((container) => {
      const attachments = Array.from(container.querySelectorAll('.file-container'))
      const actionBar = container.parentElement.querySelector('#action-bar')

      if (attachments.length > 0) {
        container.classList.remove('hidden')
        actionBar.classList.remove('hidden')
      } else {
        container.classList.add('hidden')
        actionBar.classList.add('hidden')
      }
    })
  }

  removeTopBorder () {
    this.containers.forEach((container) => {
      const attachments = Array.from(container.querySelectorAll('.file-container'))
      const lastAttachment = attachments[attachments.length - 1]

      if (attachments.length > 0) {
        lastAttachment.classList.add('border-t-0')
      }
    })
  }

  initEventListeners () {
    this.multiSelectIconHandler('attachment')

    const bulkDeleteButton = this.el.querySelector('#resource-delete')

    if (!bulkDeleteButton) return

    bulkDeleteButton.addEventListener('click', () => {
      this.softDeleteResources()
    })

    const indivdualResourceRemovalButton = Array.from(this.el.querySelectorAll('.icon-container'))

    indivdualResourceRemovalButton.forEach((icon) => {
      icon.addEventListener('click', (e) => {
        this.softDeleteResource(e)
      })
    })
  }

  urlManager (type = 'remove', removedId = null, element) {
    const container = element.closest('.multi-select-attachment-container')
    const checkboxesArr = Array.from(container.querySelectorAll('input[type="checkbox"]'))
    const attachmentIds = []

    checkboxesArr.forEach((checkbox) => {
      const attachmentId = checkbox.closest('.file-container').dataset.attachmentId

      if (type === 'remove') {
        if (attachmentId === removedId) return

        attachmentIds.push(attachmentId)
      } else {
        attachmentIds.push(attachmentId)
      }
    })

    const ids = encodeURIComponent(JSON.stringify(attachmentIds))
    const myLink = container.querySelector('#resource-download')

    myLink.setAttribute('href', '/attachments?ids=' + ids)
  }

  hoverMenuHandler () {
    this.attachedFiles.forEach(attachment => {
      const hoverMenu = attachment.querySelector('.hover-menu')

      attachment.addEventListener('mouseenter', () => {
        hoverMenu.classList.remove('hidden')
      })

      attachment.addEventListener('mouseleave', () => {
        hoverMenu.classList.add('hidden')
      })
    })
  }

  handleAttachment (row, val, icon, arr) {
    const trashIcon = row.querySelector('.trash-icon')

    arr.forEach((item) => {
      item.classList[val]('line-through', 'text-gray-400')
    })

    row.classList[val]('removed')
    trashIcon.innerHTML = icon
  }

  softDeleteResources () {
    const checkedCheckboxes = this.checkboxes.filter(box => box.checked)

    checkedCheckboxes.forEach((checkbox) => {
      this.softDeleteResource(checkbox)
    })
  }

  softDeleteResource (element) {
    const row = this.getResourceRow(element)

    const hiddenPrimaryField = row.querySelector('.hidden-primary-field')
    const arr = [
      row.querySelector('.file-name'),
      row.querySelector('.file-size'),
      row.querySelector('.uploaded-at'),
    ]

    if (!row.classList.contains('removed')) {
      this.handleAttachment(row, 'add', this.undoIcon, arr)
      hiddenPrimaryField.value = 'false'
    } else {
      this.handleAttachment(row, 'remove', this.removeIcon, arr)
      hiddenPrimaryField.value = 'true'
    }
  }

  getResourceRow (element) {
    if (element.target) { element = element.target }

    return element.closest('.file-container')
  }

  changeBackgroundColor () {
    const checkboxes = Array.from(document.querySelectorAll('#attachment-checkbox'))

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('click', (e) => {
        const attachment = e.target.closest('.file-container')

        attachment.classList.toggle('animate-attachment')
      })
    })
  }

  get removeIcon() {
    return new Icon('icon-delete', { title: 'Remove' }).asString()
  }

  get undoIcon() {
    return new Icon('icon-replay', { title: 'Undo' }).asString()
  }
}

export default MultiAttachment
